<ng-container *ngIf="bookingData$ | async as bookingData; else loader">
  <ng-container *ngIf="step$ | async as step">
    <markant-platform-cms-background></markant-platform-cms-background>
    <markant-platform-modal-bridge>
      <markant-dialog
        class="booking-dialog"
        [open]="true"
        (close)="goBack(bookingData.cartridge.id, bookingData.priceRequest?.id)"
      >
        <div class="dialog-wrapper">
          <markant-platform-booking-header
            [cartridgeId]="bookingData.cartridge.id"
            [cartridgeVariantName]="bookingData.variant.name"
            [priceRequestId]="bookingData.priceRequest?.id"
            [bookingStep]="step"
          >
          </markant-platform-booking-header>
          <div class="content-wrapper">
            <markant-platform-booking-form
              *ngIf="step === 'form'"
              [bookingData]="bookingData"
              [additionalBookingDataForm]="additionalBookingDataForm"
              (goNext)="updateDataAndGoToOverview()"
            >
            </markant-platform-booking-form>
            <markant-platform-booking-overview
              *ngIf="step === 'overview'"
              [bookingData]="bookingData"
              [isLoading]="(loading$ | async) ?? false"
              (goBack)="goTo('form')"
              (goNext)="bookVariantAndGoToConfirmation(bookingData)"
            >
            </markant-platform-booking-overview>
            <markant-platform-booking-confirmation
              *ngIf="step === 'confirmation'"
              [bookingData]="bookingData"
            ></markant-platform-booking-confirmation>
          </div>
        </div>
      </markant-dialog>
    </markant-platform-modal-bridge>
  </ng-container>
</ng-container>

<ng-template #loader>
  <div class="spinner-wrapper">
    {{ 'general.loading' | transloco }}
    <markant-spinner></markant-spinner>
  </div>
</ng-template>

<markant-platform-modal-bridge
  *ngIf="isAlreadyBookedDialogOpen$ | async as isAlreadyBookedDialogOpen"
>
  <markant-dialog
    class="already-booked-dialog"
    [open]="true"
    [headTitle]="'booking.overview.errorAlreadyBooked.title' | transloco"
    (close)="closeAlreadyBookedDialog()"
  >
    <div>{{ 'booking.overview.errorAlreadyBooked.text' | transloco }}</div>
    <div slot="footer">
      <markant-button variant="primary" data-markant-dialog-action="cancel">
        <span>{{ 'general.close' | transloco }}</span>
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
